import { Injectable } from '@angular/core';
import { ApiService } from '@uranda/commons';
import {
  AccountSubscription,
  SubscriptionPlan,
} from '../app/models/subscription.model';


@Injectable({
  providedIn: 'root',
})
export class SubscriptionService extends ApiService {

  async getPlans(): Promise<SubscriptionPlan[]> {
    const response = (await this.get('/v1/subscriptions/plans')).data;
    // L'API ritorna un oggetto con chiavi numeriche {"1": {...}, "2": {...}}
    if (Array.isArray(response)) return response;
    return Object.values(response) as SubscriptionPlan[];
  }

  async getPlanById(id: number): Promise<SubscriptionPlan> {
    return (await this.get(`/v1/subscriptions/plans/${id}`)).data;
  }

  async getActiveSubscriptions(): Promise<AccountSubscription[]> {
    return (await this.get('/v1/subscriptions/active')).data;
  }

  async getSubscriptionHistory(): Promise<AccountSubscription[]> {
    return (await this.get('/v1/subscriptions/history')).data;
  }

  async subscribeToPlan(planId: number, autoRenewal = true): Promise<AccountSubscription> {
    return (await this.post(`/v1/subscriptions/subscribe/${planId}`, { autoRenewal })).data;
  }

  async cancelSubscription(planId: number): Promise<{ success: boolean; message: string }> {
    return (await this.delete(`/v1/subscriptions/cancel/${planId}`)).data;
  }

  async reactivateSubscription(planId: number): Promise<AccountSubscription> {
    return (await this.put(`/v1/subscriptions/reactivate/${planId}`, {})).data;
  }

  async setAutoRenewal(planId: number, enabled: boolean): Promise<AccountSubscription> {
    // enabled va come query param (?enabled=...), letto dal backend con @RequestParam
    return (await this.put(`/v1/subscriptions/auto-renewal/${planId}?enabled=${enabled}`, {})).data;
  }

  async getAvailableQuoteRequestsCount(): Promise<number> {
    return (await this.get('/v1/partner/quote-requests/available-count')).data;
  }
}

